var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59064 11.5922L12.7607 3.42212C12.9197 3.26317 13.0458 3.07447 13.1318 2.8668C13.2178 2.65912 13.2621 2.43653 13.2621 2.21174C13.2621 1.98695 13.2178 1.76436 13.1318 1.55669C13.0458 1.34901 12.9197 1.16031 12.7607 1.00136C12.6018 0.842407 12.4131 0.716321 12.2054 0.630298C11.9977 0.544275 11.7751 0.5 11.5503 0.5C11.3256 0.5 11.103 0.544275 10.8953 0.630298C10.6876 0.716321 10.4989 0.842407 10.34 1.00136L2.16987 9.17145M4.59064 11.5922L1.26208 12.5L2.16987 9.17145M4.59064 11.5922L3.38026 10.3818L2.16987 9.17145",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.349a1ddcaa0df0588117a9a0b7b9344b.svg";
export { ForwardRef as ReactComponent };